import {Injectable} from '@angular/core';
import {IProdGridService} from 'prod-grid';
import {HttpClient} from "@angular/common/http";
import {HttpExtraParams} from 'prod-shared';
import {Observable} from 'rxjs';
import {Permission} from "../models/permission";

@Injectable({providedIn: 'root'})
export class PermissionService implements IProdGridService {
  constructor(private httpClient: HttpClient) {
  }

  getProdGridData(params?: HttpExtraParams): Observable<Object> {
    return this.httpClient.get<{ data: { result: Permission[], totalCount: number }, success: boolean }>(`/api/permissions`, {params});
  }
}
